import Card from "./Card";
import Standard from "./Standard";

export default {
  card: Card,
  standard: Standard,
  clean: Standard,
};
